<template>
  <v-container
    fluid
    class="psTable p4-report"
  >
    <ps-button
      color="primary"
      :click="showAddRowDialog"
    >
      Add Rows
    </ps-button>
    <div
      v-show="dialog"
      id="addRowDialog"
    >
      <ps-table
        ref="addRowTable"
        :data="new Array()"
        :options="addRowOptions"
      />
      <ps-button
        color="primary"
        :click="saveNewRows"
      >
        Apply Rows
      </ps-button>
    </div>
    <div class="tableContainer">
      <psReportHeader
        id="filter"
        header-title="ProfitSword Clients"
        :show-search-bar="true"
        :show-add-button="false"
        @search-event="searchEvent"
        @save-event="saveData"
        @refresh-event="refreshData"
      />
      <ps-table
        ref="mainTable"
        class="table-striped"
        :data="allClients"
        :options="options"
        :filter-string="search"
      />      
    </div>

    <PacketDialog class="p4-report"
      v-if="isClientPacketDialogvisible"
      v-model="isClientPacketDialogvisible"
      :psClientGuid="currentGuid"
    />
  </v-container>
  
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import Vuetify from "../plugins/vuetify";
import nucleus from "ps-nucleus";
import PacketDialog from "./PacketDialog.vue";

export default {
    name: "PsClientAdmin",
    components: {    
    PacketDialog: PacketDialog
  },
    data() {
        return {
            currentGuid: "",
            ssoOptions: null,
            isHidden: false,
            absolute: false,
            dialog: false,
            zIndex: 5,
            currentRowID: null,
            currentCell: null,
            isClientPacketDialogvisible:false,
            options: {
                columnVertAlign: "center",
                index: "psClientId",        
                resizableColumns: true,
                history: true,
                layout: "fitColumns",
                addRowPos: "top",
                height: "75vh",
                movableColumns: true,
                pagination: "local",
                paginationSize: 30,
                paginationAddRow: "table",
                paginationSizeSelector: [10, 20, 30, 50, 100],

                cellEdited: cell => {
                    cell._cell.edited = true;
                    var editedRow = cell.getRow();
                    editedRow._row.data.edited = true;
                    this.setRowCondition(editedRow);
                },
                rowSelected: row => {
                    this.setRowDeleteCondition(row);
                },
                rowDeselected: row => {
                    this.setRowUnDeleteCondition(row);
                },
                columns: [
                    {
                        formatter: this.deleteIcon,
                        width: 40,
                        align: "center",
                        cellClick: function(e, cell) {
                            cell.getRow().toggleSelect();
                        },
                        headerSort: false
                    },
                    {
                        formatter: this.copyIcon,
                        width: 40,
                        align: "center",
                        cellClick: function(e, cell) {
                            var data = cell.getRow()._row.data;
                            var sorters = this.getSorters();
                            this.clearSort();
                            this.addRow(data);
                            this.setSort(sorters);
                        },
                        headerSort: false
                    },
                    {
                        formatter: this.cellFormatter,
                        title: "Client Name",
                        field: "psClientName",
                        editor: "input"
                    },
                    {
                        title: "<div class='passwordComplexity'> Password Complexity</div>",
                        align: "center",
                        columns: [
                            {
                                title: "Duration (Days)",
                                field: "psClientPasswordExpirationDays",
                                width: 154,
                                sorter: "number",
                                editor: "input"
                            },
                            {
                                title: "Min Length",
                                field: "psClientPasswordComplexityLength",
                                editor: "input",
                                width: 140
                            },
                            {
                                title: "Capital",
                                field: "psClientPasswordComplexityCapital",
                                width: 105,
                                align: "center",
                                responsive: true,
                                formatter: this.checkBoxFormatter,
                                cellClick: (e, cell) => {
                                    if (e.srcElement.tagName == "INPUT") {
                                        cell.setValue(!cell.getValue());
                                        this.setRowCondition(cell.getRow());
                                    }
                                }
                            },
                            {
                                title: "Number",
                                field: "psClientPasswordComplexityNumber",
                                width: 105,
                                formatter: this.checkBoxFormatter,
                                align: "center",
                                cellClick: (e, cell) => {
                                    if (e.srcElement.tagName == "INPUT") {
                                        var newValue = !cell.getValue();
                                        cell.setValue(newValue);
                                        this.setRowCondition(cell.getRow());
                                    }
                                }
                            },
                            {
                                title: "Special Char",
                                field: "psClientPasswordComplexitySpecial",
                                align: "center",
                                width: 135,
                                formatter: this.checkBoxFormatter,
                                cellClick: (e, cell) => {
                                    if (e.srcElement.tagName == "INPUT") {
                                        cell.setValue(!cell.getValue());
                                        this.setRowCondition(cell.getRow());
                                    }
                                }
                            }
                        ]
                    },
                    {
                        title: "Reuse History",
                        field: "psClientPasswordHistoryMinimum",
                        align: "center",
                        width: 150,
                        editor: "input"
                    },
                    {
                        title: "Lockout attempts",
                        field: "psClientMaxLoginAttempts",
                        align: "center",
                        width: 150,
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Lockout Minutes",
                        field: "psClientUserLockoutMinutes",
                        align: "center",
                        width: 150,
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Global ID",
                        field: "psClientGuid",
                        align: "left",
                        sorter: "date"
                    },
                    {
                        title: "Package",
                        width: 120,
                        align: "center",
                        field: "",
                        formatter: this.pickerCell,
                        cellClick: this.pickerCellClick,
                        align: "left"
                    },
                    {
                        title: "Single Sign On",
                        field: "singleSignOnName",
                        formatter: ({_cell}) => { 
                            var ComponentClass = Vue.extend(nucleus.components.PSSelect);
                            var instance = new ComponentClass({
                                propsData: {
                                    items: this.ssoOptions, 
                                    currentValue: this.getIdFromSsoName(_cell.value), 
                                    cell: _cell, 
                                    dense: "true",
                                    flat: "true"
                                },
                                vuetify: Vuetify
                            });
                            instance.$mount();

                            return instance.$el;
                        },
                        align: "left"
                    }
                ]
            },
            addRowOptions: {
                columnVertAlign: "bottom",
                layout: "fitColumns",
                height: "25vh",
                movableColumns: false,
                rowAdded: function(row) {
                    row._row.data.edited = false;
                    // var currentHeight = parseInt(this.options.height.replace("vh", ""));
                    // var newHeight = currentHeight + 6;
                    // this.setHeight(newHeight + "vh");
                    row.scrollTo();
                    this.navigateNext();
                },
                cellEdited: function(cell) {
                    var row = cell.getRow();
                    row._row.data.edited = true;
                    var rowCount = row._row.parent.activeRowsCount;
                    var currentRowPosition = row.getPosition();

                    if (currentRowPosition + 1 == rowCount) {
                        this.addRow({}).then(function(r) {});
                    }
                },
                columns: [
                    {
                        formatter: this.deleteIcon,
                        width: 40,
                        align: "center",
                        cellClick: function(e, cell) {
                            var row = cell.getRow();
                            var rowCount = row._row.parent.activeRowsCount;

                            if (rowCount > 1) {
                                row.delete();
                            } else alert("Cannot delete remaining row");
                        },
                        headerSort: false
                    },
                    {
                        title: "Client Name",
                        field: "psClientName",
                        width: 200,
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Duration (Days)",
                        field: "psClientPasswordExpirationDays",
                        width: 200,
                        sorter: "number",
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Min Length",
                        field: "psClientPasswordComplexityLength",
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Capital",
                        field: "psClientPasswordComplexityCapital",
                        width: 80,
                        align: "center",
                        formatter: this.checkBoxFormatter,
                        cellClick: (e, cell) => {
                            if (e.srcElement.tagName == "INPUT") {
                                cell.setValue(!cell.getValue());
                            }
                        },
                        headerSort: false
                    },
                    {
                        title: "Number",
                        field: "psClientPasswordComplexityNumber",
                        align: "center",
                        formatter: this.checkBoxFormatter,
                        cellClick: (e, cell) => {
                            if (e.srcElement.tagName == "INPUT") {
                                cell.setValue(!cell.getValue());
                            }
                        },
                        headerSort: false
                    },
                    {
                        title: "Special Char",
                        field: "psClientPasswordComplexitySpecial",
                        align: "center",
                        formatter: this.checkBoxFormatter,
                        cellClick: (e, cell) => {
                            if (e.srcElement.tagName == "INPUT") {
                                cell.setValue(!cell.getValue());
                            }
                        },
                        headerSort: false
                    },
                    {
                        title: "Reuse History",
                        field: "psClientPasswordHistoryMinimum",
                        align: "center",
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Lockout attempts",
                        field: "PSClientMaxLoginAttempts",
                        align: "center",
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Lockout Minutes",
                        field: "PSClientUserLockoutMinutes",
                        align: "center",
                        editor: "input",
                        headerSort: false
                    },
                    {
                        title: "Single Sign On",
                        field: "singleSignOnName",
                        formatter: ({_cell}) => { 
                            var ComponentClass = Vue.extend(nucleus.components.PSSelect);
                            var instance = new ComponentClass({
                                propsData: {
                                    items: this.ssoOptions, 
                                    currentValue: this.getIdFromSsoName(_cell.value), 
                                    cell: _cell, 
                                    dense: "true",
                                    flat: "true"
                                },
                                vuetify: Vuetify
                            });
                            instance.$mount();

                            return instance.$el;
                        },
                        align: "left"
                    }
                ]
            },
            search: ""
        };
    },
    computed: {
        ...mapGetters(["allClients"])
    },
    created() {
       
    },
    mounted() {
        window.Bus.$on("updatedData", (v) => {

            var table = this.$refs.mainTable.$refs.tabulator.getInstance();

            if(v.length > 0 && v !== "updatedData")
            {
                var firstRow = table.getRows()[0];
                firstRow._row.data.psClientGuid = v;
                table.redraw(true);
            }

            var rows = table.getRows();
            var rowsDeleted = false;
            rows.forEach(function(thisRow) {
                if (thisRow._row.data.markedForDeletion == true){
                    thisRow._row.delete();
                    rowsDeleted = true;
                }
            });
            if(rowsDeleted === true){
                table.redraw(true);
            }
        });

        window.Bus.$on("cellValueChanged", (cell) => {
            cell[0].element.classList.add("edited-textfield");
        });
        this.getSingleSignOnProviders();
    },
    methods: {
        ...mapActions(["fetchClients", "updateClients"]),
        ...mapMutations(["setClients"]),
        async getSingleSignOnProviders() {
            axios.get(localConfig.authenticationURL + "/api/SingleSignOn/All")
                .then(response=>{
                    this.ssoOptions = response.data;
                    this.fetchClients();
                });
        },        
        refreshEvent() {},
        navigateNext() {
            var table = this.$refs.addRowTable.$refs.tabulator.getInstance();
            var row = table.getRowFromPosition(0, true);
            var cell = row.getCells()[1];
            cell.edit(true);
        },
    pickerCellClick(e, cell) {
      var field = cell.getField();      
      var row = cell.getRow();
      var index = row.getPosition();
      this.currentRowID = index;
      this.currentCell = cell;
      this.currentGuid = row._row.data.psClientGuid;
      this.setPacketDialogVisible(cell);
      //this.setPickerVisible(index, cell, "is" + field + "pickervisible");
    },
        addRow() {
            var table = this.$refs.mainTable.$refs.tabulator.getInstance();
            var sorters = table.getSorters();

            var rows = table.getRows();

            var newRowExists = false;
            rows.forEach(function(thisRow) {
                if (
                    (thisRow._row.data.edited == false ||
            thisRow._row.data.edited == undefined) &&
          thisRow._row.data.psClientId == -1
                ) {
                    newRowExists = true;
                }
            });

            if (newRowExists == true) {
                return;
            }

            table.addRow({ psClientId: -1, edited: false }).then(function(row) {
                table.setSort(sorters);

                var topRowIndex = -1;

                rows.forEach(function(thisRow) {
                    var position = thisRow.getPosition(true);

                    if (position == 0) {
                        topRowIndex = thisRow._row.data.psClientId;
                    }

                    if (position == 1 && topRowIndex == -1) {
                        topRowIndex = thisRow._row.data.psClientId;
                    }
                });

                rows = table.getRows();
                rows.forEach(function(row) {
                    if (row._row.data.psClientId == -1) {
                        row.move(topRowIndex, true);
                        row.getElement().classList.add("edits-saved");
                    }
                });
            });
        },
        getSelectedRows() {
            var table = this.$refs.mainTable.$refs.tabulator.getInstance();
            var selectedRows = table.getSelectedRows();

            selectedRows.forEach(function(r) {
                console.log(r._row.data.psClientGuid); // Guid to delete.
            });
        },
        setRowCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allClients[currentRowPosition].changed = true;
        },
        setRowDeleteCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allClients[currentRowPosition].markedForDeletion = true;           
            row._row.data.markedForDeletion = true;
            this.allClients[currentRowPosition].created = false;           
            row._row.data.created = false;
        },
        setRowUnDeleteCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allClients[currentRowPosition].markedForDeletion = false;
            row._row.data.markedForDeletion = false;
        },
        refreshData() {
            var table = this.$refs.mainTable.$refs.tabulator.getInstance();
            table.clearData();
            this.fetchClients();  
            table.setData(this.allClients);
        },
        searchEvent(val) {
            this.search = val;
        },
            pickerCell(cell, formatterParams, onRendered) {
        var row = cell.getRow();
        var oldValue =  (typeof(cell._cell) == 'undefined') ? null : cell._cell.oldValue;
  
        if (oldValue != null && oldValue != cell.getValue()) {
            $(cell.getElement()).addClass('redBorder');
        }
        var cellValue = cell.getValue();
        if (cellValue === null || cellValue === undefined) {
          cellValue = "";
        }
  //todo: these styles should not be inline.  put them in a stylesheet somewhere.
        return  "<span style='vertical-align:top;border-radius:3px'><span class='icon-edit-24' /></span><span style='vertical-align:top;'>&nbsp;&nbsp;" +
          cellValue +
          "</span>";
        
    },
        getIdFromSsoName(name) {
            var tag = this.ssoOptions.filter(
                f => { return f.name === name; }
            );

            if(tag !== undefined && tag.length > 0)
                return tag[0].id;
            else
                return name;
        },
        saveData() {
            var table = this.$refs.mainTable.$refs.tabulator.getInstance();

            var data = table.getRows();

            data.forEach(function(item) {
                if(item._row.data.markedForDeletion === true)
                {
                    item.delete();
                }
            });

            this.updateClients();
            
            var cols = table.getColumns();
            cols.forEach(function(col){
                var cells = col.getCells();
                cells.forEach(function(cell){
                    cell.getElement().classList.remove("edited-textfield");
                });
            });

        },
        checkBoxFormatter(cell, formatterParams, onRendered) {
            var row = cell.getRow();
            if (row._row.data.psClientId == -1) {
                return cell.getValue() == true
                    ? "<input type=\"checkbox\" checked tabindex=\"0\"/>"
                    : "<input type=\"checkbox\" tabindex=\"0\"/>";
            }
            var oldValue = cell._cell.oldValue;

            if (oldValue != null && oldValue != cell.getValue()) {
                cell.getElement().classList.add("edited-textfield");
            }

            return cell.getValue() == true
                ? "<input type=\"checkbox\" checked tabindex=\"0\" />"
                : "<input type=\"checkbox\" tabindex=\"0\" />";
        },
        cellFormatter(cell, formatterParams, onRendered) {
            var row = cell.getRow();
            if (row._row.data.psClientId == -1) return cell.getValue();

            var oldValue = cell._cell.oldValue;

            if (oldValue != null && oldValue != cell.getValue()) {
                cell.getElement().classList.add("edited-textfield");
            }
            return cell.getValue();
        },
        deleteIcon() {
            return "<span class='icon-trash-24 largeIco'></span></i>";
        },
        copyIcon() {
            return "<span class='icon-copy-24 largeIco'></span></i>";
        },
        showAddRowDialog() {
            this.dialog = !this.dialog;
            var table = this.$refs.addRowTable.$refs.tabulator.getInstance();
            table.clearData();

            Vue.nextTick(function() {
                table.addRow({ psClientName: "" }).then(function(row) {
                    setTimeout(function() {
                        row.scrollTo();
                        var cells = row.getCells();
                        cells[1].edit(true);
                    }, 20);
                });
            });
        },
        saveNewRows() {
            var addRowTable = this.$refs.addRowTable.$refs.tabulator.getInstance();
            var newRows = addRowTable.getRows();
            var mainTable = this.$refs.mainTable.$refs.tabulator.getInstance();
            var sorters = mainTable.getSorters();

            mainTable.clearSort();

            newRows.forEach(r => {
                if (r._row.data.edited == true) {
                    r._row.data.created = true;
                    mainTable
                        .addData(Object.assign({}, r._row.data), true)
                        .then(function(row) {});
                }
            });
            addRowTable.clearData();

            addRowTable.addRow({ psClientName: "" }).then(function(row) {
                row.scrollTo();
                var cells = row.getCells();
                cells[1].edit(true);
            });

            this.setClients(mainTable.getData());
            this.showAddRowDialog();
        },
        // Shows the picker dialog.
        setPacketDialogVisible(cell) {            
            this.isClientPacketDialogvisible = true;
        } 
    }
};
</script>

<style lang='scss'>
@import "../styles/PsClientAdmin.scss";
</style>
